import React from 'react';
import Summary from './Summary';

interface Summary {
  id: number;
  final_at: string;
  healthcare: string;
  doctor: string;
  speciality: string;
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
  date: string;
}

interface GroupedSummary {
  date: string;
  summaries: Summary[];
}

interface HealthRecordProps {
  healthRecord: GroupedSummary[];
}

const HealthRecordList: React.FC<HealthRecordProps> = ({ healthRecord }) => {
  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);

    return new Intl.DateTimeFormat('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }
  
  return (
    <div className="relative p-4 border-gray-200 ">
      {healthRecord.map((group: GroupedSummary, idx: number) => (
        <div key={idx} className="relative space-y-8 pb-8">
          <div className="absolute -top-9 -left-4 z-10">
            <div className="inline-block bg-teal-500 text-white px-4 py-1 text-sm font-semibold">
              {formatDate(group.date)}
            </div>
          </div>
          
          {group.summaries.map((summary: Summary, index: number) => (
            <Summary key={index} summary={summary} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default HealthRecordList;
